import { useEffect } from 'react';
import HeroSection from './components/HeroSection';
import QuizSection from './components/QuizSection';
import DoresSection from './components/DoresSection';
import MetodoSection from './components/MetodoSection';
import ProgramaSection from './components/ProgramaSection';
import ModulosSection from './components/ModulosSection';
import EspecialistasSection from './components/EspecialistasSection';
import DiferencialOfertaSection from './components/DiferencialOfertaSection';
import ProximosPassosSection from './components/ProximosPassosSection';
import FooterSection from './components/FooterSection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const schemaData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebPage',
      '@id': `${SITE_URL}/#webpage`,
      url: `${SITE_URL}/`,
      name: 'Transformação Real 60D | Consultoria Empresarial',
      description:
        'Programa intensivo presencial de estruturação empresarial em Manaus/AM. Em 60 dias, organize sua empresa, controle o financeiro e crie previsibilidade de vendas. Vagas limitadas.',
      inLanguage: 'pt-BR',
      isPartOf: { '@id': `${SITE_URL}/#website` },
    },
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      url: `${SITE_URL}/`,
      name: 'Transformação Real 60D',
      inLanguage: 'pt-BR',
    },
    {
      '@type': 'EducationalOrganization',
      '@id': `${SITE_URL}/#organization`,
      name: 'Transformação Real 60D',
      url: `${SITE_URL}/`,
      description:
        'Consultoria empresarial presencial em Manaus/AM com programa intensivo de 60 dias para estruturação de empresas.',
      address: {
        '@type': 'PostalAddress',
        addressLocality: 'Manaus',
        addressRegion: 'AM',
        addressCountry: 'BR',
      },
      areaServed: {
        '@type': 'City',
        name: 'Manaus',
      },
    },
    {
      '@type': 'Course',
      '@id': `${SITE_URL}/#course`,
      name: 'Transformação Real 60D',
      description:
        'Programa intensivo presencial de estruturação empresarial em Manaus/AM. Em 60 dias, organize sua empresa, controle o financeiro e crie previsibilidade de vendas.',
      provider: { '@id': `${SITE_URL}/#organization` },
      courseMode: 'onsite',
      inLanguage: 'pt-BR',
      hasCourseInstance: {
        '@type': 'CourseInstance',
        courseMode: 'onsite',
        location: {
          '@type': 'Place',
          name: 'Manaus',
          address: {
            '@type': 'PostalAddress',
            addressLocality: 'Manaus',
            addressRegion: 'AM',
            addressCountry: 'BR',
          },
        },
      },
      teaches: [
        'Mapa de Gargalos e Alavancas',
        'Gestão e Estrutura Operacional',
        'Organização Financeira',
        'Estrutura Comercial',
        'Inovação e Eficiência Empresarial',
        'Inteligência Artificial Aplicada ao Negócio',
      ],
    },
    {
      '@type': 'FAQPage',
      '@id': `${SITE_URL}/#faq`,
      mainEntity: [
        {
          '@type': 'Question',
          name: 'O que é o programa Transformação Real 60D?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'É um programa intensivo presencial de estruturação empresarial em Manaus/AM. Em 60 dias, você organiza sua empresa, controla o financeiro e cria previsibilidade de vendas.',
          },
        },
        {
          '@type': 'Question',
          name: 'Onde acontece o programa de consultoria empresarial?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'O programa acontece presencialmente em Manaus, Amazonas (AM), Brasil.',
          },
        },
        {
          '@type': 'Question',
          name: 'Quais módulos fazem parte do programa?',
          acceptedAnswer: {
            '@type': 'Answer',
            text: 'O programa é composto por 6 módulos: Mapa de Gargalos e Alavancas, Gestão e Estrutura Operacional, Organização Financeira, Estrutura Comercial, Inovação e Eficiência Empresarial e Inteligência Artificial Aplicada ao Negócio.',
          },
        },
      ],
    },
  ],
};

export default function HomePage() {
  useEffect(() => {
    const scriptId = 'schema-home';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify(schemaData);
    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return (
    <main className="min-h-screen">
      <HeroSection />
      <QuizSection />
      <DoresSection />
      <MetodoSection />
      <ProgramaSection />
      <EspecialistasSection />
      <ModulosSection />
      <DiferencialOfertaSection />
      <ProximosPassosSection />
      <FooterSection />
    </main>
  );
}
